import type { ComponentProps } from "react";
import { useShallow } from "zustand/react/shallow";
import { TerminalInput } from "@/components/ui/terminal-input";
import { TerminalOutput } from "@/components/ui/terminal-output";
import { useStore } from "@/lib/store";
import { cn } from "@/lib/utils";

const Terminal = function Terminal({ className }: ComponentProps<"div">) {
  const { terminalOutputs, terminalExecute } = useStore(
    useShallow((s) => ({
      terminalOutputs: s.terminalOutputs,
      terminalExecute: s.terminalExecute,
    })),
  );

  return (
    <div
      data-testid="terminal"
      className={cn(
        "flex flex-col bg-muted w-full h-full text-left",
        className,
      )}
    >
      <TerminalOutput outputs={terminalOutputs} />
      <TerminalInput onEnter={terminalExecute} outputs={terminalOutputs} />
    </div>
  );
};

export { Terminal };
